import { partialRight } from "lodash";

import { ValidatorFunction, ConfigurableItemValidator, MaxLengthValidator, ValidatorFunctions } from './ConfigurableItemValidator';

export function MaxLength(length: number): ValidatorFunctions {
    const validators: ValidatorFunction[] = [];

    validators.push(partialRight(MaxLengthValidator, length));

    return ConfigurableItemValidator(validators);
}
